import {useCallback, useContext} from 'preact/hooks';

import {AppState} from 'utilities/app-state';

import {LayoutProps} from '../../types';
import {ShopPromiseLayoutInner} from '../ShopPromiseLayoutInner';

import styles from './ShopPromiseLayout.css';

export function ShopPromiseLayout(layoutProps: LayoutProps) {
  const {zipFormVisible, mainButtonRef} = useContext(AppState);
  const callback = useCallback(
    (event: Event) => {
      if (
        mainButtonRef.current === event.target ||
        !['INPUT', 'BUTTON', 'A'].includes(
          (event.target as HTMLElement).tagName.toUpperCase(),
        )
      ) {
        // preserve keyboard interactions
        zipFormVisible.value = !zipFormVisible.value;
      }
    },
    [zipFormVisible, mainButtonRef],
  );

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={callback}
      onKeyPress={callback}
      aria-expanded={zipFormVisible.value.toString()}
      className={styles.clickable}
      ref={mainButtonRef}
    >
      <ShopPromiseLayoutInner {...layoutProps}>
        {layoutProps.children}
      </ShopPromiseLayoutInner>
    </div>
  );
}
